// Exports the full Sales Lead record (every field, not just the ones shown
// in the list table) to a downloadable CSV file.
import { landingUrlFor } from './fields';

const formatDate = (epochSeconds) =>
  epochSeconds ? new Date(epochSeconds * 1000).toLocaleDateString() : '';

const COLUMNS = [
  { label: 'Lead ID', value: (l) => l.leadId },
  { label: 'Lead Type', value: (l) => l.leadType },
  { label: 'Contact Name', value: (l) => l.contactName },
  { label: 'Business Name', value: (l) => l.businessName },
  { label: 'Business Email', value: (l) => l.businessEmail },
  { label: 'Business Phone', value: (l) => l.businessPhone },
  { label: 'Address 1', value: (l) => l.addr1 },
  { label: 'Address 2', value: (l) => l.addr2 },
  { label: 'City', value: (l) => l.city },
  { label: 'State', value: (l) => l.state },
  { label: 'ZIP', value: (l) => l.zip },
  { label: 'Sales Rep', value: (l) => l.salesRep },
  { label: 'Sales Rep Phone', value: (l) => l.salesRepPhone },
  { label: 'Trial Days', value: (l) => l.trialDays },
  { label: 'Trial Scans', value: (l) => l.trialScans },
  { label: 'Discount %', value: (l) => l.discountPercent },
  { label: 'Status', value: (l) => l.status },
  { label: 'Query String', value: (l) => l.queryString },
  { label: 'Personalized Link', value: (l) => landingUrlFor(l.queryString) },
  { label: 'Click Count', value: (l) => l.clickCount || 0 },
  { label: 'Last Clicked At', value: (l) => formatDate(l.lastClickedAt) },
  { label: 'Printed At', value: (l) => formatDate(l.printedAt) },
  { label: 'Exported At', value: (l) => formatDate(l.exportedAt) },
  { label: 'Signup Count', value: (l) => l.signupCount || 0 },
  { label: 'Conversion Count', value: (l) => l.conversionCount || 0 },
  { label: 'Created At', value: (l) => formatDate(l.createdAt) },
  { label: 'Updated At', value: (l) => formatDate(l.updatedAt) },
];

// Quotes a value if it contains a comma, quote, or newline; doubles any
// embedded quotes per RFC 4180.
const csvCell = (value) => {
  const str = value === null || value === undefined ? '' : String(value);
  return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

export function exportLeadsToCsv(leads, filename = `sales-leads-export-${new Date().toISOString().slice(0, 10)}.csv`) {
  const header = COLUMNS.map((c) => csvCell(c.label)).join(',');
  const rows = leads.map((lead) => COLUMNS.map((c) => csvCell(c.value(lead))).join(','));
  const csv = [header, ...rows].join('\r\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
